
import Assert from "tbAssert";

import BinaryTree from "./BinaryTree";

const mLogSvc = new WeakMap();

class BinaryTreeFactory {
    constructor($log) {
        Assert.StrictAssert($log != null, "Assertion Failed: Missing log service dependency");

        mLogSvc.set(this, $log);
    }

    buildTree(rootNodeData) {
        let logSvc = mLogSvc.get(this);
        return new BinaryTree(logSvc, rootNodeData);
    }
}

BinaryTreeFactory.$inject = [ "$log" ];

export default BinaryTreeFactory;


//////////////////
// WEBPACK FOOTER
// ./src/services/binary-tree/BinaryTreeFactory.js
// module id = 5Hbr
// module chunks = 1